module.exports = function getResource(label) {
    const resources = {
        freeReturns: 'Retours gratuits',
        exclusions: 'see details/exclusions.*'
    };

    return resources[label];
};
